import { Component, OnInit, AfterViewInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Router } from '@angular/router';
import { Member, MemberRegisterService } from './member-register.service';
import { User, UserService } from './user.service';
import { Company, CompanyService } from './company.service';
import { CommonService } from '../app.service';
import { LocationInfo, GooglemapService } from "../common/googlemap.service";
import { LOGON_INFO, COMP_TYPE, USER_TYPE } from '../app.constants';
import { MessageService } from '../common/message.service';
import $ from 'jquery';


@Component({
    selector: 'member-regist',
    templateUrl: 'member-regist.component.html',
    providers: [MemberRegisterService, UserService, GooglemapService, CompanyService]
})
export class MemberRegistComponent implements OnInit {

    @ViewChild(NgForm) f: NgForm;

    member: Member;
    address_search_list: LocationInfo[];
    isPartnerUpdate: boolean;

    isClient: boolean;
    isUpdate: boolean;

    constructor(
        private memberRegisterService: MemberRegisterService,
        private router: Router,
        private commonService: CommonService,
        private userService: UserService,
        private companyService: CompanyService,
        private mapService: GooglemapService,
        private msgService: MessageService
    ) {  }

    ngOnInit() {
        this.member = new Member(new Company, new User);
        this.isPartnerUpdate = this.router.url == "/partner-update";
        this.isUpdate = this.router.url.search(/update/) > -1;
        this.isClient = this.router.url.search(/client/) > -1;
        
        if (this.isUpdate) {
            if (this.isClient) {
                this.userService.getUserInfo(LOGON_INFO.USER_ID)
                .subscribe(
                    data => {
                        this.member.user = data;
                        this.member.company.tel = data.tel;
                        this.member.company.zipcode = data.zipcode;
                        this.member.company.address = data.address;
                        this.member.company.address_detail = data.address_detail;
                        this.member.user.emailConfirm = data.email;
                    }
                );
            }
            else {
                this.companyService.getCompanyInfo(LOGON_INFO.COMP_ID)
                .subscribe(
                    data => {
                        this.member.company = data;
                        this.member.user.userid = data.user[0].userid;
                        this.member.user.name = data.user[0].name;
                        this.member.user.email = data.user[0].email;
                        this.member.user.emailConfirm = data.user[0].email;
                    }
                );
            }
        }
    }

    ngAfterViewInit(): void {
        document.getElementById("userid").focus();
    }



    checkUseridDuplicate(isValid: boolean) {
        if (isValid) {
            this.userService.checkUseridDuplicate(this.member.user.userid)
            .subscribe(
                data => {
                    if (data['results'].length == 0) {
                        this.clearCustomError("userid");
                    }
                    else {
                        this.setCustomError("userid");
                    }
                }
            );
        }
    }


    checkPasswordEqual(isValid: boolean) {
        if (isValid) {
            if (this.member.user.password != this.member.user.passwordConfirm) {
                this.setCustomError("passwordConfirm");
            }
            else {
                this.clearCustomError("passwordConfirm");
            }
        }
    }

    checkEmailEqual(isValid: boolean) {
        if (isValid) {
            if (this.member.company.email != this.member.company.emailConfirm || this.member.user.email != this.member.user.emailConfirm) {
                this.setCustomError("emailConfirm");
            }
            else {
                this.clearCustomError("emailConfirm");
            }
        }
    }


    /*
    selectFromMap() {
        $('#mapModal').modal('show');
    }
    //googlemapからのcallback
    setLocationInfo(locInfo: LocationInfo) {
        if (this.router.url === "router.url === '/transport-regist'") {
            this.member.company.zipcode = locInfo.zipcode;
            this.member.company.address = locInfo.todohuken + locInfo.address;
            this.member.company.address_lat = this.lat = locInfo.lat;
            this.member.company.address_lng = this.lng = locInfo.lng;
        } else {
            this.member.user.zipcode = locInfo.zipcode;
            this.member.user.address = locInfo.todohuken + locInfo.address;
            this.member.user.address_lat = this.lat = locInfo.lat;
            this.member.user.address_lng = this.lng = locInfo.lng;
        }
        $('#zipcode_feedback').css('display', 'none');
    }
    */


    //郵便番号情報を取得
    getZipcodeInfo(isValid: boolean) {
        if (isValid) {
            this.commonService.searchAddress(this.member.company.zipcode.replace('-',''))
                .subscribe(
                    data => {
                        if (data['results'].length == 1) {
                            this.setAddress(data['results'][0]);
                        } else if (data['results'].length > 1) {
                            this.address_search_list = data['results'];
                            $('#addressSearchModal').modal('show');
                        } else {
                            this.setCustomError("zipcode");
                            this.member.company.address = null;
                        }
                    }
                );
        }
        else {
            this.member.company.address = null;
        }
    }
    //address検索結果modalからのcallback
    setAddress(locInfo: LocationInfo) {
        this.member.company.address = locInfo.todohuken + locInfo.address;
        this.clearCustomError("zipcode");
    }



    memberRegist() {
        if (this.f.invalid) {
            return;
        }

        this.mapService.getLatLngFromAddress(this.member.company.address + this.member.company.address_detail)
        .then(
            data => {
                if (!this.isClient) {
                    this.member.user.div = USER_TYPE.TRANS_MANAGER;
                    this.member.user.tel = this.member.company.tel;
                    this.member.company.comp_type = COMP_TYPE.HEAD;
                    this.clearCustomError("address_detail");

                    this.memberRegisterService.registMember(this.member)
                    .subscribe(
                        data => {
                            this.msgService.addInfo("会員登録が正常完了しました。");
                            this.router.navigate(["/login"]);
                        }
                    );
                }
                else {
                    this.member.user.tel = this.member.company.tel;
                    this.member.user.zipcode = this.member.company.zipcode;
                    this.member.user.address = this.member.company.address;
                    this.member.user.address_detail = this.member.company.address_detail;
                    this.clearCustomError("address_detail");

                    if (this.isClient && this.isUpdate) {
                        this.userService.updateUser(this.member.user)
                        .subscribe(
                            data => {
                                this.msgService.addInfo("会員情報更新が正常完了しました。");
                                this.router.navigate(["/cargo/client"]);
                            }
                        );
                    }
                    else {
                        this.userService.registUser(this.member.user)
                        .subscribe(
                            data => {
                                this.msgService.addInfo("会員登録が正常完了しました。");
                                this.router.navigate(["/login"]);
                            }
                        );
                    }
                }
            }
        )
        .catch(
            error => {
                this.member.company.address_lat = null;
                this.member.company.address_lng = null;
                this.member.user.address_lat = null;
                this.member.user.address_lng = null;
                this.setCustomError("address_detail");
            }
        );
    }


    cancel() {
        this.router.navigate([this.isClient && this.isUpdate ? "/cargo/client" : "/login"]);
    }


    setCustomError(control_name: string) {
        this.f.controls[control_name].setErrors({'custom':true});
        $('#'+control_name).addClass("is-invalid");
    }

    clearCustomError(control_name: string) {
        this.f.controls[control_name].setErrors(null);
        $('#'+control_name).removeClass("is-invalid");
    }

}


// WEBPACK FOOTER //
// ./src/app/member-kanri/member-regist.component.ts